import { createApp } from 'vue';
import liveRow from "./components/liveRow.vue";
import sf from "./modules/smartyfaces";
import slugify from "slugify";

    window.liveGames = createApp(
        {
            delimiters: ['[[', ']]'],
            components: {liveRow},
            data: () => ({
                filter: 'all',
                loadingStatusAll: false,
                liveData: {},
                collapsedLeagues: [],
                l: {},
                loading: false,
                deviceId: null,
                deviceToken: null,
                favorites: false,
                favoritesList: [],
                sound: true
            }),
            mounted() {
                this.deviceId = VisitorNotification.getDeviceId()
                this.deviceToken = VisitorNotification.getToken()
                this.load('collapsedLeagues')
                this.load('favoritesList')
                this.load('favorites')
                this.load('sound')
                window.liveSound = this.sound
                this.reloadLive();
                $("#app").parent().show();
            },
            created() {

            },
            computed: {
                visibleNotificationBtn() {
                    return VisitorNotification.isVisibleNotifButtons()
                }
            },
            methods: {
                filterActiveClass(type) {
                    return this.filter === type ? 'active' : ''
                },
                setFilter(type) {
                    this.filter = type
                    this.reloadLive()
                },
                reloadLive() {
                    this.loading = true
                    sf.ajax('LivescoreAction::getLiveData', {
                            filter: this.filter,
                            deviceId: this.deviceId,
                            favoritesList: this.favoritesList
                        }
                    ).then(res => {
                        this.liveData = res.data.result
                        this.loading = false
                        this.$nextTick(() => {
                            window.SF.attachBsElements();
                        })
                    }).catch(err => {
                        this.loading = false
                    })
                },
                toggleNotificationsAll() {
                    this.loadingStatusAll = true
                    VisitorNotification.toggle2(this.deviceId, 'live', 0, (res) => {
                        this.loadingStatusAll = false
                        if (res) {
                            sf.ajax('VisitorNotificationAction::toggle2', {
                                device_id: this.deviceId,
                                token: this.deviceToken,
                                reference_type: 'live',
                                reference_id: 0
                            }).then(res => {
                                let status = res.data.result.status
                                this.liveData.notificationStatus = status
                            })
                        }
                    })
                },
                toggleLeaguePanel(league_id) {
                    if (this.collapsedLeagues.includes(league_id)) {
                        let index = this.collapsedLeagues.indexOf(league_id);
                        this.collapsedLeagues.splice(index, 1);
                    } else {
                        this.collapsedLeagues.push(league_id)
                    }
                    this.store('collapsedLeagues')
                },
                toggleLeagueNotification(league) {
                    league.loading = true
                    VisitorNotification.toggle2(this.deviceId, 'live-league', league.league_id, (res) => {
                        league.loading = false
                        if (res) {
                            sf.ajax('VisitorNotificationAction::toggle2', {
                                device_id: this.deviceId,
                                token: this.deviceToken,
                                reference_type: 'live-league',
                                reference_id: league.league_id
                            }).then(res => {
                                console.log(res.data.result)
                                let status = res.data.result.status
                                league.notificationStatus = status
                            })
                        }
                    })
                },
                isCollapsed(league_id) {
                    let index = this.collapsedLeagues.indexOf(league_id);
                    return index >= 0
                },
                loadTranslations(translations) {
                    this.l = translations
                },
                toggleFav() {
                    this.favorites = !this.favorites
                    this.store('favorites')
                },
                leagueVisible(league) {
                    if (!this.favorites) {
                        return true
                    }
                    let fav_count = 0
                    for (let i = 0; i < league.results.length; i++) {
                        if (league.results[i].favorite) {
                            fav_count++
                        }
                    }
                    return fav_count > 0
                },
                storeFavorites(game) {
                    if (game.favorite) {
                        this.favoritesList.push(game.live_id)
                    } else {
                        let index = this.favoritesList.indexOf(game.live_id);
                        this.favoritesList.splice(index, 1);
                    }
                    this.store('favoritesList')
                },
                store(name) {
                    localStorage.setItem(name, JSON.stringify(this[name]));
                },
                load(name) {
                    let val
                    try {
                        val = localStorage.getItem(name)
                        if (val) {
                            this[name] = JSON.parse(val)
                        }
                    } catch (e) {

                    }
                },
                toggleSound() {
                    this.sound = !this.sound
                    window.liveSound = this.sound
                    this.store('sound')
                },
                updateGame(gameId, data) {
                    let game = this.$refs[`game-${gameId}`][0].game
                    game.live_status = data.status
                    game.period = data.period
                    game.period = data.period
                    let r1 = null
                    let r2 = null
                    if (data.res && data.res.indexOf("[") > 0) {
                        const regex = /(\d+):(\d+) \[(\d+):(\d+)\]/gm;
                        let m = regex.exec(data.res)
                        r1 = `${m[3]} <sup>${m[1]}</sup>`
                        r2 = `${m[4]} <sup>${m[2]}</sup>`
                    } else {
                        r1 = data.r1
                        r2 = data.r2
                    }
                    game.r1 = r1
                    game.r2 = r2
                },
                leagueHref(league) {
                    let slug = slugify(league.league_name, {lower: true, strict: true})
                    return `/league/${league.league_id}-${slug}`
                },
                clubsImageCss(league) {
                    return `<style lang="text/css">
.team-img-s-${league.league_id} {
background-image:url('/img/clubs/${league.league_id}/42');
}
</style>`
                }
            }
        }


    ).mount("#app");
